import SettingsContent from '../Wrapper';
import AgentHome from './Index';
import AgentHeader from './AgentHeader.vue';
import AgentHint from './AgentHint.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agents'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_MGMT.HEADER',
        showCountKey: 'agents/getAgents',
        icon: 'people',
        showNewButton: false,
        hintComponent: AgentHint,
      },
      children: [
        {
          path: '',
          name: 'agents_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'agent_list',
          component: AgentHome,
          components: {
            default: AgentHome,
            header: AgentHeader,
          },
          roles: ['administrator'],
        },
      ],
    },
  ],
};
